import React from "react";

export default function LoadingGIF() {
  return (
    <div className="center-me">
      <img className="loading-gif rotate linear infinite" src={"https://cdn.discordapp.com/attachments/626125078521708554/850515439577726996/loading.gif"} alt="loading..." />;
    </div>
  );
}
